// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 퀘스트 스팟 관리자 바 스타일.
 *
 * 수치는 Figma 1920×1200 기준을 그대로 적는다(node 1966:44176 TITLEBAR / 1965:48860 Modal).
 * 실기기는 1280×800 도 있으므로 \`--qsab-s\`(스케일)로 한 번에 줄인다 — 값을 두 벌 적으면
 * 디자인이 바뀔 때 한쪽만 고쳐져 어긋난다. 경계 1600px 는 \`QuestTagPage.css\` 와 같다.
 *
 * 폰트: 디자인은 Pretendard Variable 이나 tools 에 없어 기본 스택을 상속한다(임의 도입 금지).
 * 모든 클래스는 \`qsab-\` 접두로 다른 화면과 충돌을 막는다.
 */

.qsab-corner,
.qsab-backdrop,
.qsab-bar {
  --qsab-s: 0.667; /* 1280 / 1920 */
}

@media (min-width: 1600px) {
  .qsab-corner,
  .qsab-backdrop,
  .qsab-bar {
    --qsab-s: 1;
  }
}

/* ── 숨은 터치존 (오른쪽 아래) ────────────────────────────────
   투명하고 아무 표시가 없다. 고객이 우연히 5회를 채우지 않도록 크지 않게 두되,
   운영자가 빠르게 5번 누를 만한 크기는 확보한다. */
.qsab-corner {
  position: fixed;
  right: 0;
  bottom: 0;
  width: calc(120px * var(--qsab-s));
  height: calc(120px * var(--qsab-s));
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  z-index: 40;
  -webkit-tap-highlight-color: transparent;
}

/* ── 비밀번호 모달 ───────────────────────────────────────── */
.qsab-backdrop {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(25px);
  z-index: 60;
}

.qsab-modal {
  box-sizing: border-box;
  width: calc(1200px * var(--qsab-s));
  max-width: calc(100vw - 48px);
  min-height: calc(560px * var(--qsab-s));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: calc(64px * var(--qsab-s));
  padding: calc(32px * var(--qsab-s));
  background: #fff;
  border: 1px solid #ececec;
  border-radius: calc(80px * var(--qsab-s));
  box-shadow: 0 16px 24px 0 rgba(0, 0, 0, 0.05);
  color: #0d0d0d;
}

.qsab-modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(48px * var(--qsab-s));
}

.qsab-modal-heads {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(12px * var(--qsab-s));
  text-align: center;
}

.qsab-modal-title {
  margin: 0;
  font-size: calc(40px * var(--qsab-s));
  font-weight: 600;
  line-height: 1.2;
  color: #0d0d0d;
}

.qsab-modal-sub {
  margin: 0;
  font-size: calc(32px * var(--qsab-s));
  font-weight: 500;
  line-height: 1.3;
  color: #585c64;
}

.qsab-input-box {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: calc(16px * var(--qsab-s));
  width: calc(680px * var(--qsab-s));
  max-width: 100%;
  padding: calc(24px * var(--qsab-s)) calc(28px * var(--qsab-s));
  background: #fff;
  border: 2px solid #dcdcdc;
  border-radius: calc(16px * var(--qsab-s));
}

/* 틀린 비밀번호를 테두리로도 알린다 — 문구만으로는 태블릿에서 눈에 덜 띈다. */
.qsab-input-box-error {
  border-color: #e5484d;
}

/* 입력 표시 — \`<input>\` 이 아니다(OS 키보드 차단). 점 개수로 몇 자 눌렀는지 보여 준다. */
.qsab-dots {
  flex: 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: calc(16px * var(--qsab-s));
  height: calc(48px * var(--qsab-s));
  font-size: calc(32px * var(--qsab-s));
  color: #0d0d0d;
}

.qsab-dots-ph {
  color: #bbb;
}

.qsab-dots-plain {
  letter-spacing: 0.24em;
}

.qsab-dot {
  width: calc(20px * var(--qsab-s));
  height: calc(20px * var(--qsab-s));
  border-radius: 50%;
  background: #0d0d0d;
  flex: none;
}

/* ── 앱 자체 숫자 키패드 ──────────────────────────────────
   OS 키보드를 쓰지 않으므로 터치 목표를 크게 잡는다(장갑·아이 손 고려). */
.qsab-keypad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: calc(16px * var(--qsab-s));
  width: calc(680px * var(--qsab-s));
  max-width: 100%;
}

.qsab-key {
  height: calc(96px * var(--qsab-s));
  border: 2px solid #dcdcdc;
  border-radius: calc(16px * var(--qsab-s));
  background: #fff;
  font-family: inherit;
  font-size: calc(40px * var(--qsab-s));
  font-weight: 600;
  line-height: 1;
  color: #0d0d0d;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  /* 연속 탭 시 텍스트가 선택돼 파랗게 뜨는 것을 막는다. */
  -webkit-user-select: none;
          user-select: none;
}

.qsab-key:active {
  background: #f0f0f0;
}

/* 지우기 계열은 숫자와 구분 — 급할 때 잘못 누르는 것을 줄인다. */
.qsab-key-fn {
  background: #f5f5f5;
  color: #666;
}

.qsab-key-fn:active {
  background: #e6e6e6;
}

.qsab-eye {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: calc(32px * var(--qsab-s));
  height: calc(32px * var(--qsab-s));
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  overflow: hidden;
}

.qsab-eye img {
  width: 100%;
  height: 100%;
  display: block;
}

.qsab-modal-error {
  margin: 0;
  font-size: calc(28px * var(--qsab-s));
  font-weight: 600;
  line-height: 1.3;
  color: #e5484d;
  text-align: center;
}

.qsab-modal-btns {
  display: flex;
  gap: calc(24px * var(--qsab-s));
  width: calc(680px * var(--qsab-s));
  max-width: 100%;
}

.qsab-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: calc(26px * var(--qsab-s)) calc(32px * var(--qsab-s));
  border: 0;
  border-radius: calc(16px * var(--qsab-s));
  font-family: inherit;
  font-size: calc(32px * var(--qsab-s));
  font-weight: 600;
  line-height: calc(44px * var(--qsab-s));
  cursor: pointer;
}

.qsab-btn-cancel {
  flex: none;
  width: calc(200px * var(--qsab-s));
  background: #f5f5f5;
  color: #666;
}

.qsab-btn-ok {
  flex: 1 0;
  min-width: 0;
  background: #007800;
  color: #fff;
}

.qsab-btn-cancel:active { background: #ebebeb; }
.qsab-btn-ok:active { background: #006400; }

/* ── 타이틀바 ───────────────────────────────────────────── */
.qsab-bar {
  box-sizing: border-box;
  position: fixed;
  top: calc(40px * var(--qsab-s));
  left: calc(40px * var(--qsab-s));
  right: calc(40px * var(--qsab-s));
  height: calc(120px * var(--qsab-s));
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 calc(40px * var(--qsab-s));
  background: #fff;
  border-radius: calc(32px * var(--qsab-s));
  box-shadow: 0 24px 12px rgba(0, 0, 0, 0.12);
  color: #1a1a1a;
  z-index: 50;
}

.qsab-ico {
  width: calc(40px * var(--qsab-s));
  height: calc(40px * var(--qsab-s));
  display: block;
  flex: none;
}

.qsab-bar-back,
.qsab-bar-save {
  display: inline-flex;
  align-items: center;
  gap: calc(12px * var(--qsab-s));
  padding: 0;
  border: 0;
  background: transparent;
  font-family: inherit;
  font-size: calc(32px * var(--qsab-s));
  font-weight: 600;
  line-height: calc(40px * var(--qsab-s));
  color: #1a1a1a;
  white-space: nowrap;
  cursor: pointer;
}

.qsab-bar-back:active,
.qsab-bar-save:active { opacity: 0.6; }

/* 중앙 콤보 — 표시는 텍스트+화살표, 실제 선택은 위에 겹친 투명 select 가 받는다. */
.qsab-bar-center {
  position: relative;
  display: flex;
  align-items: center;
  gap: calc(20px * var(--qsab-s));
  min-width: 0;
  padding: 0 calc(12px * var(--qsab-s));
}

.qsab-bar-no,
.qsab-bar-name {
  font-size: calc(36px * var(--qsab-s));
  font-weight: 600;
  line-height: calc(44px * var(--qsab-s));
  white-space: nowrap;
}

/* 미션명이 길어도 바가 깨지지 않게 이 항목만 줄인다(번호·구분자는 유지). */
.qsab-bar-name {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(560px * var(--qsab-s));
}

.qsab-bar-div {
  font-size: calc(36px * var(--qsab-s));
  font-weight: 300;
  line-height: calc(44px * var(--qsab-s));
  color: #999;
}

.qsab-bar-select {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  border: 0;
  background: transparent;
  font-size: calc(36px * var(--qsab-s)); /* 모바일 브라우저 확대 방지 */
  cursor: pointer;
}

.qsab-bar-select:disabled {
  cursor: not-allowed;
}

/* ── 잠금 표시 ─────────────────────────────────────────────
   🔴 \`cursor: not-allowed\` 만으로는 **커서가 없는 태블릿에서 아무 신호가 안 된다.**
      투명 select 라 disabled 여도 화면이 그대로여서, 운영자가 "터치가 안 먹는다" 로
      보고했다(2026-08-07). 잠긴 것이 **눈에 보여야** 한다. */
.qsab-bar-center-locked .qsab-bar-no,
.qsab-bar-center-locked .qsab-bar-div,
.qsab-bar-center-locked .qsab-bar-name {
  opacity: 0.45;
}

.qsab-bar-lock {
  flex: none;
  font-size: calc(28px * var(--qsab-s));
  font-weight: 600;
  line-height: calc(44px * var(--qsab-s));
  white-space: nowrap;
  color: #b45309;
  background: #fef3c7;
  border-radius: 999px;
  padding: 0 calc(24px * var(--qsab-s));
}
`, "",{"version":3,"sources":["webpack://./src/components/quest/QuestSpotAdminBar.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;;AAEF;;;EAGE,eAAe,EAAE,gBAAgB;AACnC;;AAEA;EACE;;;IAGE,WAAW;EACb;AACF;;AAEA;;gCAEgC;AAChC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,wCAAwC;AAC1C;;AAEA,yDAAyD;AACzD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAE9B,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,6BAA6B;EAC7B,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,mCAAmC;EACnC,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;EACzC,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,kCAAkC;EAClC,eAAe;EACf,8DAA8D;EAC9D,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA,+CAA+C;AAC/C;EACE,qBAAqB;AACvB;;AAEA,8DAA8D;AAC9D;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,kCAAkC;EAClC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;+CAC+C;AAC/C;EACE,aAAa;EACb,qCAAqC;EACrC,+BAA+B;EAC/B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,mCAAmC;EACnC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,kCAAkC;EAClC,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8DAA8D;EAC9D,SAAS;EACT,yCAAyC;EACzC,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA,0BAA0B,mBAAmB,EAAE;AAC/C,sBAAsB,mBAAmB,EAAE;;AAE3C,0DAA0D;AAC1D;EACE,sBAAsB;EACtB,eAAe;EACf,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;EACjC,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qCAAqC;EACrC,gBAAgB;EAChB,yCAAyC;EACzC,2CAA2C;EAC3C,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;wBACwB,YAAY,EAAE;;AAEtC,uDAAuD;AACvD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;EACZ,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;EACrC,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,qCAAqC,EAAE,mBAAmB;EAC1D,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;8CAG8C;AAC9C;;;EAGE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,qCAAqC;AACvC","sourcesContent":["/**\n * 퀘스트 스팟 관리자 바 스타일.\n *\n * 수치는 Figma 1920×1200 기준을 그대로 적는다(node 1966:44176 TITLEBAR / 1965:48860 Modal).\n * 실기기는 1280×800 도 있으므로 `--qsab-s`(스케일)로 한 번에 줄인다 — 값을 두 벌 적으면\n * 디자인이 바뀔 때 한쪽만 고쳐져 어긋난다. 경계 1600px 는 `QuestTagPage.css` 와 같다.\n *\n * 폰트: 디자인은 Pretendard Variable 이나 tools 에 없어 기본 스택을 상속한다(임의 도입 금지).\n * 모든 클래스는 `qsab-` 접두로 다른 화면과 충돌을 막는다.\n */\n\n.qsab-corner,\n.qsab-backdrop,\n.qsab-bar {\n  --qsab-s: 0.667; /* 1280 / 1920 */\n}\n\n@media (min-width: 1600px) {\n  .qsab-corner,\n  .qsab-backdrop,\n  .qsab-bar {\n    --qsab-s: 1;\n  }\n}\n\n/* ── 숨은 터치존 (오른쪽 아래) ────────────────────────────────\n   투명하고 아무 표시가 없다. 고객이 우연히 5회를 채우지 않도록 크지 않게 두되,\n   운영자가 빠르게 5번 누를 만한 크기는 확보한다. */\n.qsab-corner {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  width: calc(120px * var(--qsab-s));\n  height: calc(120px * var(--qsab-s));\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  z-index: 40;\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* ── 비밀번호 모달 ───────────────────────────────────────── */\n.qsab-backdrop {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.4);\n  -webkit-backdrop-filter: blur(25px);\n  backdrop-filter: blur(25px);\n  z-index: 60;\n}\n\n.qsab-modal {\n  box-sizing: border-box;\n  width: calc(1200px * var(--qsab-s));\n  max-width: calc(100vw - 48px);\n  min-height: calc(560px * var(--qsab-s));\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: calc(64px * var(--qsab-s));\n  padding: calc(32px * var(--qsab-s));\n  background: #fff;\n  border: 1px solid #ececec;\n  border-radius: calc(80px * var(--qsab-s));\n  box-shadow: 0 16px 24px 0 rgba(0, 0, 0, 0.05);\n  color: #0d0d0d;\n}\n\n.qsab-modal-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: calc(48px * var(--qsab-s));\n}\n\n.qsab-modal-heads {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: calc(12px * var(--qsab-s));\n  text-align: center;\n}\n\n.qsab-modal-title {\n  margin: 0;\n  font-size: calc(40px * var(--qsab-s));\n  font-weight: 600;\n  line-height: 1.2;\n  color: #0d0d0d;\n}\n\n.qsab-modal-sub {\n  margin: 0;\n  font-size: calc(32px * var(--qsab-s));\n  font-weight: 500;\n  line-height: 1.3;\n  color: #585c64;\n}\n\n.qsab-input-box {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  gap: calc(16px * var(--qsab-s));\n  width: calc(680px * var(--qsab-s));\n  max-width: 100%;\n  padding: calc(24px * var(--qsab-s)) calc(28px * var(--qsab-s));\n  background: #fff;\n  border: 2px solid #dcdcdc;\n  border-radius: calc(16px * var(--qsab-s));\n}\n\n/* 틀린 비밀번호를 테두리로도 알린다 — 문구만으로는 태블릿에서 눈에 덜 띈다. */\n.qsab-input-box-error {\n  border-color: #e5484d;\n}\n\n/* 입력 표시 — `<input>` 이 아니다(OS 키보드 차단). 점 개수로 몇 자 눌렀는지 보여 준다. */\n.qsab-dots {\n  flex: 1 0 0;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: calc(16px * var(--qsab-s));\n  height: calc(48px * var(--qsab-s));\n  font-size: calc(32px * var(--qsab-s));\n  color: #0d0d0d;\n}\n\n.qsab-dots-ph {\n  color: #bbb;\n}\n\n.qsab-dots-plain {\n  letter-spacing: 0.24em;\n}\n\n.qsab-dot {\n  width: calc(20px * var(--qsab-s));\n  height: calc(20px * var(--qsab-s));\n  border-radius: 50%;\n  background: #0d0d0d;\n  flex: none;\n}\n\n/* ── 앱 자체 숫자 키패드 ──────────────────────────────────\n   OS 키보드를 쓰지 않으므로 터치 목표를 크게 잡는다(장갑·아이 손 고려). */\n.qsab-keypad {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: calc(16px * var(--qsab-s));\n  width: calc(680px * var(--qsab-s));\n  max-width: 100%;\n}\n\n.qsab-key {\n  height: calc(96px * var(--qsab-s));\n  border: 2px solid #dcdcdc;\n  border-radius: calc(16px * var(--qsab-s));\n  background: #fff;\n  font-family: inherit;\n  font-size: calc(40px * var(--qsab-s));\n  font-weight: 600;\n  line-height: 1;\n  color: #0d0d0d;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  /* 연속 탭 시 텍스트가 선택돼 파랗게 뜨는 것을 막는다. */\n  user-select: none;\n}\n\n.qsab-key:active {\n  background: #f0f0f0;\n}\n\n/* 지우기 계열은 숫자와 구분 — 급할 때 잘못 누르는 것을 줄인다. */\n.qsab-key-fn {\n  background: #f5f5f5;\n  color: #666;\n}\n\n.qsab-key-fn:active {\n  background: #e6e6e6;\n}\n\n.qsab-eye {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: calc(32px * var(--qsab-s));\n  height: calc(32px * var(--qsab-s));\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.qsab-eye img {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.qsab-modal-error {\n  margin: 0;\n  font-size: calc(28px * var(--qsab-s));\n  font-weight: 600;\n  line-height: 1.3;\n  color: #e5484d;\n  text-align: center;\n}\n\n.qsab-modal-btns {\n  display: flex;\n  gap: calc(24px * var(--qsab-s));\n  width: calc(680px * var(--qsab-s));\n  max-width: 100%;\n}\n\n.qsab-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: calc(26px * var(--qsab-s)) calc(32px * var(--qsab-s));\n  border: 0;\n  border-radius: calc(16px * var(--qsab-s));\n  font-family: inherit;\n  font-size: calc(32px * var(--qsab-s));\n  font-weight: 600;\n  line-height: calc(44px * var(--qsab-s));\n  cursor: pointer;\n}\n\n.qsab-btn-cancel {\n  flex: none;\n  width: calc(200px * var(--qsab-s));\n  background: #f5f5f5;\n  color: #666;\n}\n\n.qsab-btn-ok {\n  flex: 1 0 0;\n  min-width: 0;\n  background: #007800;\n  color: #fff;\n}\n\n.qsab-btn-cancel:active { background: #ebebeb; }\n.qsab-btn-ok:active { background: #006400; }\n\n/* ── 타이틀바 ───────────────────────────────────────────── */\n.qsab-bar {\n  box-sizing: border-box;\n  position: fixed;\n  top: calc(40px * var(--qsab-s));\n  left: calc(40px * var(--qsab-s));\n  right: calc(40px * var(--qsab-s));\n  height: calc(120px * var(--qsab-s));\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 calc(40px * var(--qsab-s));\n  background: #fff;\n  border-radius: calc(32px * var(--qsab-s));\n  box-shadow: 0 24px 12px rgba(0, 0, 0, 0.12);\n  color: #1a1a1a;\n  z-index: 50;\n}\n\n.qsab-ico {\n  width: calc(40px * var(--qsab-s));\n  height: calc(40px * var(--qsab-s));\n  display: block;\n  flex: none;\n}\n\n.qsab-bar-back,\n.qsab-bar-save {\n  display: inline-flex;\n  align-items: center;\n  gap: calc(12px * var(--qsab-s));\n  padding: 0;\n  border: 0;\n  background: transparent;\n  font-family: inherit;\n  font-size: calc(32px * var(--qsab-s));\n  font-weight: 600;\n  line-height: calc(40px * var(--qsab-s));\n  color: #1a1a1a;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.qsab-bar-back:active,\n.qsab-bar-save:active { opacity: 0.6; }\n\n/* 중앙 콤보 — 표시는 텍스트+화살표, 실제 선택은 위에 겹친 투명 select 가 받는다. */\n.qsab-bar-center {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: calc(20px * var(--qsab-s));\n  min-width: 0;\n  padding: 0 calc(12px * var(--qsab-s));\n}\n\n.qsab-bar-no,\n.qsab-bar-name {\n  font-size: calc(36px * var(--qsab-s));\n  font-weight: 600;\n  line-height: calc(44px * var(--qsab-s));\n  white-space: nowrap;\n}\n\n/* 미션명이 길어도 바가 깨지지 않게 이 항목만 줄인다(번호·구분자는 유지). */\n.qsab-bar-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: calc(560px * var(--qsab-s));\n}\n\n.qsab-bar-div {\n  font-size: calc(36px * var(--qsab-s));\n  font-weight: 300;\n  line-height: calc(44px * var(--qsab-s));\n  color: #999;\n}\n\n.qsab-bar-select {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  border: 0;\n  background: transparent;\n  font-size: calc(36px * var(--qsab-s)); /* 모바일 브라우저 확대 방지 */\n  cursor: pointer;\n}\n\n.qsab-bar-select:disabled {\n  cursor: not-allowed;\n}\n\n/* ── 잠금 표시 ─────────────────────────────────────────────\n   🔴 `cursor: not-allowed` 만으로는 **커서가 없는 태블릿에서 아무 신호가 안 된다.**\n      투명 select 라 disabled 여도 화면이 그대로여서, 운영자가 \"터치가 안 먹는다\" 로\n      보고했다(2026-08-07). 잠긴 것이 **눈에 보여야** 한다. */\n.qsab-bar-center-locked .qsab-bar-no,\n.qsab-bar-center-locked .qsab-bar-div,\n.qsab-bar-center-locked .qsab-bar-name {\n  opacity: 0.45;\n}\n\n.qsab-bar-lock {\n  flex: none;\n  font-size: calc(28px * var(--qsab-s));\n  font-weight: 600;\n  line-height: calc(44px * var(--qsab-s));\n  white-space: nowrap;\n  color: #b45309;\n  background: #fef3c7;\n  border-radius: 999px;\n  padding: 0 calc(24px * var(--qsab-s));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
